module.exports = __webpack_public_path__ + "static/img/77-2.f327bdf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/77-2.jpg
// module id = VsMM
// module chunks = 0